var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatMessage typeExpire"},[_c('div',{staticClass:"msgBox"},[(_vm.expires)?_c('Countdown',{attrs:{"end-date":new Date(_vm.expires*1000),"timertype":'timer_box'},on:{"timer-ended":_vm.timerEnded}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }